import React from "react";
import { formatNumber, nFormatter, formatMoney } from "utils/currencyFormat";
import { formatCurrency } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
const GiaoDichChoDuyetTableRows = ({ list, pageIndex, pageSize, btnAccessClick, btnDeleteClick}) => {
    return list.List.map((item, index) => {
        return (
            <div className="custom-table-row" key={"item" + index} style={{ minHeight: "40px" }}>
                <div className="custom-table-cell" style={{ width: "7%" }}>
                    <span className="mobile-column-name color7-bold">STT</span>
                    <div className="center-wrapper" >
                        <p className="text-center color7">{(pageIndex - 1) * pageSize + index + 1}</p>
                    </div>
                </div>
                <div className="custom-table-cell" style={{ width: "10%" }}>
                    <span className="mobile-column-name color7-bold">Mã giao dịch</span>
                    <div className="center-wrapper">
                        {item.Code}
                    </div>
                </div>
                <div className="custom-table-cell" style={{ width: "10%" }}>
                    <span className="mobile-column-name color7-bold">Loại giao dịch</span>
                    <div className="center-wrapper">
                        {item.Type === 51
                            ? "Nhập quỹ"
                            : item.Type === 52
                                ? "Rút quỹ"
                                : "Chuyển quỹ"}
                    </div>
                </div>
                <div className="custom-table-cell" style={{ width: "10%" }}>
                    <span className="mobile-column-name color7-bold">Thời gian</span>
                    <div className="center-wrapper">
                        {getDate(item.Time)}
                    </div>
                </div>
                <div className="custom-table-cell" style={{ width: "10%" }}>
                    <span className="mobile-column-name color7-bold">Người tạo</span>
                    <div className="center-wrapper">
                        {item.NhanVien}
                    </div>
                </div>
                <div className="custom-table-cell" style={{ width: "20%", textAlign: "end", paddingRight: "5%" }}>
                    <span className="mobile-column-name color7-bold">Tổng tiền</span>
                    <div className="center-wrapper color-do-bold">
                        {formatNumber(item.Value)}
                    </div>
                </div>
                <div className="custom-table-cell" style={{ width: "25%" }}>
                    <span className="mobile-column-name color7-bold">Ghi chú</span>
                    <div className="center-wrapper"
                        style={{
                            maxWidth: "100%",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            margin: 0,
                        }}
                        title={item.Note}
                    >
                        {item.Note}
                    </div>
                </div>
                <div className="custom-table-cell" style={{ width: "8%" }}>
                    <span className="mobile-column-name color7-bold">Thao tác</span>
                    <div style={{display:"flex",justifyContent:"space-around",gap:"15px",paddingLeft:"10px"}} >
                        <a
                            className="iconTableMorman"
                            title="Duyệt"
                            onClick={() => btnAccessClick(item.ThuChiId)}
                        >
                            <i className="fas fa-check blue"></i>
                        </a>
                        <a
                            className="iconTableMorman"
                            title="Xóa"
                            onClick={() => btnDeleteClick(item.ThuChiId)}
                        >
                            <img src="/app-assets/images/icon-xoa-v2.png" />
                        </a>
                    </div>
                </div>
            </div>
        )
    });
};
const GiaoDichChoDuyetTable = ({ list, pageIndex, pageSize, btnAccessClick, btnDeleteClick}) => {
    if (!list || list.List.length === 0) {
        return (
            <div className="custom-table-row">
                <div className="custom-table-cell text-center red" style={{ width: "100%" }}>
                    Không có dữ liệu
                </div>
            </div>
        );
    }
    return (
        <div className="Left808x200 Table-main-new css-table-ds">
            <div className="table-mobile table-mobile-hover">
                <div className="custom-table-wrapper">
                    <div className="table-headers" >
                        <div className="custom-table-header text-center " style={{ width: "7%" }}>
                            <p className="color-do-bold">
                                STT
                                <br />[{list.iTotal === 0 ? 0 : list.iTotal}]
                            </p>
                        </div>
                        <div className="custom-table-header" style={{ width: "10%" }}>
                            <p>Mã giao dịch</p>
                        </div>
                        <div className="custom-table-header" style={{ width: "10%" }}>
                            <p>Loại giao dịch</p>
                        </div>
                        <div className="custom-table-header" style={{ width: "10%" }}>
                            <p>Thời gian</p>
                        </div>
                        <div className="custom-table-header" style={{ width: "10%" }}>
                            <p>Người tạo</p>
                        </div>
                        <div className="custom-table-header" style={{ width: "20%", textAlign: "end", paddingRight: "5%" }}>
                            <p>Số tiền</p>
                        </div>
                        <div className="custom-table-header" style={{ width: "25%" }}>
                            <p>Ghi chú</p>
                        </div>
                        <div className="custom-table-header" style={{ width: "8%" }}>
                            <p>Thao tác</p>
                        </div>
                    </div>
                    <div className="custom-table-body">
                        <GiaoDichChoDuyetTableRows
                            list={list}
                            pageIndex={pageIndex}
                            pageSize={pageSize}
                            btnAccessClick={btnAccessClick}
                            btnDeleteClick={btnDeleteClick}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
};

export default GiaoDichChoDuyetTable;